<template>
  <base-draggable-modal
      :name="modal_name"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="modal_name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.model) }}</v-toolbar-title>
            <v-spacer/>
            <base-action-button v-if="canDelete" class="mr-5" :delete="true" @action="archive">
              <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("delete") }}
            </base-action-button>
          </v-toolbar>
        </template>
        <template #content>
            <v-card-text>
              <template v-for="field in usual_fields">
                <template v-if="field.name === 'description' || ((page.model === 'protectionkind' || page.model === 'equipmenttype' || page.model === 'distributiondevicefunction') && field.name === 'name')">
                  <v-text-field
                      density="default"
                      class="reg-normal text-primary"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      v-model="english_name"
                      :disabled="!canEdit"
                      hide-details
                      flat
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('en_name_desc') }}<strong>*</strong></span>
                    </template>
                  </v-text-field>
                  <v-text-field
                      density="default"
                      class="reg-normal text-primary mt-3"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      v-model="dutch_name"
                      :disabled="!canEdit"
                      hide-details
                      flat
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('nl_name_desc') }}<strong>*</strong></span>
                    </template>
                  </v-text-field>
                </template>
                <!--USUAL FIELDS-->
                <base-field
                    v-else
                    :isDisabled="!canEdit"
                    :key="field.name"
                    :modelValue="record[field.name]"
                    :field="field"
                    @change="usualFieldDataChanged"/>
              </template>
            </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal(modal_name)">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button v-if="canEdit" :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import { useAbility } from "@casl/vue"
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import {PhArchive, PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["modal_name", "page"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhArchive, PhFloppyDisk, PhX,
  },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      record: {},
      usual_fields: [],
      english_name: null,
      dutch_name: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(id) {
      this.record = {};
      this.usual_fields = [];
      this.english_name = null;
      this.dutch_name = null;
      this.openModal(this.modal_name);
      this.record = await helpFunctions.loadModel(this.$toast, this.page.name, id);
      await this.getFields();
      if (this.page.model === 'protectionkind' || this.page.model === 'equipmenttype' || this.page.model === 'distributiondevicefunction') {
        let response = await helpFunctions.postCustomRoute(this.$toast, "translations/get-by-key", { key: this.record.name }, false, false);
        response.forEach((translation) => {
          if (translation.language === 'en') {
            this.english_name = translation.value;
          }
          else if (translation.language === 'nl') {
            this.dutch_name = translation.value;
          }
        });
      }
      else {
        let response = await helpFunctions.postCustomRoute(this.$toast, "translations/get-by-key", { key: this.record.description }, false, false);
        response.forEach((translation) => {
          if (translation.language === 'en') {
            this.english_name = translation.value;
          }
          else if (translation.language === 'nl') {
            this.dutch_name = translation.value;
          }
        });
      }
    },
    async save() {
      //check if the key was created on model creation
      let key = '';
      if (this.page.model === 'protectionkind' || this.page.model === 'equipmenttype' || this.page.model === 'distributiondevicefunction') {
        key = this.record.name ? this.record.name : '';
      }
      else {
        key = this.record.description ? this.record.description : '';
      }
      //create new key if it was not created on model creation
      let new_key = '';
      if(key !== '') {
        new_key = key;
      }
      else {
        if (this.english_name) {
          key = this.$lodash.lowerCase(this.english_name);
        }
        else if (this.dutch_name) {
          key = this.$lodash.lowerCase(this.dutch_name);
        }
        new_key = key.replaceAll('(', "_").replaceAll(')', "_").replaceAll('[', "_").replaceAll(']', "_")
            .replaceAll('-', "_").replaceAll('/', "_").replaceAll('\\', "_").replace(/ /g, "_");

        if (this.page.model === 'protectionkind' || this.page.model === 'equipmenttype' || this.page.model === 'distributiondevicefunction') {
          this.record.name = new_key;
        }
        else {
          this.record.description = new_key;
        }
      }
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, this.usual_fields)) {
        if(await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          if(this.english_name) {
            await helpFunctions.postCustomRoute(this.$toast, "translations/update-by-key", { key: new_key, language: 'en', value: this.english_name }, false, false);
          }
          if(this.dutch_name) {
            await helpFunctions.postCustomRoute(this.$toast, "translations/update-by-key", { key: new_key, language: 'nl', value: this.dutch_name }, false, false);
          }
          await this.$store.dispatch("refreshTranslations");
          this.$emit('refresh');
          this.closeModal(this.modal_name);
        }
      }
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          this.$emit('refresh');
          this.closeModal(this.modal_name);
        }
      });
    },
    usualFieldDataChanged(data) {
      if(this.record[data[0]] !== data[1]) {
        this.record[data[0]] = data[1];
      }
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_update");
      this.usual_fields = response.usual_fields;
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
  },
};
</script>